import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http'; // ✅ Correct
import { TranslationService } from '../translate';

@Component({
  selector: 'app-webview',
  templateUrl: './webview.component.html',
  styleUrls: ['./webview.component.scss']
})
export class WebviewComponent implements OnInit {
  counter: number = 0; // Initialize the counter
  loading: boolean = true; // To show loading state
  error: string | null = null; // To handle errors
  selectedLang = "en";
  selectedLangDir = "en";

  constructor(private http: HttpClient, private _translate: TranslationService) {
  }

  ngOnInit(): void {
    this.incrementCounter();

    var settings = localStorage.getItem('settings');
    var settingsLocal = JSON.parse(settings);

    if (settings != null) {
      if (settingsLocal.lang == "English") {
        settingsLocal.lang = "en";
      }
      this._translate.use(settingsLocal.lang);
      this.selectedLang = settingsLocal.lang;
      this.selectedLangDir = settingsLocal.dir;

    } else {
      this._translate.use("en");
      this.selectedLang = "en";
      this.selectedLangDir = "ltr";
    }
  }

  // Method to increment the counter and get the updated count
  incrementCounter(): void {
    const incrementApiUrl = 'https://us-central1-counterdatabase-d9895.cloudfunctions.net/api/v1/website-view';

    this.http.post<{ message: string; collection: string; count: number }>(incrementApiUrl, { collection: 'Inheritance' }).subscribe({
      next: (response) => {
        this.counter = response.count; // Use the count from the API response
        this.loading = false;
      },
      error: (err) => {
        console.error('Error incrementing the counter:', err);
        this.error = 'Failed to increment the counter';
        this.loading = false;
      }
    });
  }

}
